import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import ChartContainer from "../components/ChartContainer";
import Divider from "@mui/material/Divider";
import api from "../../../components/services/api";

import { ResponsiveBar } from "@nivo/bar";
import DatePicker from "@mui/lab/DatePicker";
import LineChart from "../components/LineChart";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import { ResponsivePie } from "@nivo/pie";
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import moment from "moment";
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
});
export default function Dashboard() {
  const [value, setValue] = useState(new Date());
  const [year, setYear] = useState(new Date());
  const [date, setDate] = useState(new Date());
  const [forecast, setForecast] = useState([]);
  const [revenueAndExpense, setRevenueAndExpense] = useState([]);
  const [revenueByType, setRevenueByType] = useState([]);
  const [type, setType] = useState("");

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const hexChars = "23456789ABD";
  const getRandomColor = () =>
    `#${Array.from({ length: 6 })
      .map(() => hexChars[Math.floor(Math.random() * 11)])
      .join("")}`;

  const data = revenueByType?.map((x) => {
    return {
      'Type': x?.Type, 'RevemueAmount': parseFloat(x?.RevemueAmount, 10).toFixed(2)
    }
  }).map((datum) => ({
    ...datum,
    color: getRandomColor(),
  }));

  const getBarColor = (bar) => bar.data.color;

  const getForecast = async () => {
    const res = await api.get(`api/financial/dashboard/forecast?year=${year ? year.getFullYear() : ''}`)
    const data = await res.data
    if (res.meta.status === true) {
      setForecast(data)
    }
  }

  const getRevenueAndExpense = async () => {
    const res = await api.get(`api/financial/dashboard/revenueAndExpense?year=${value ? value.getFullYear() : ''}`)
    const data = await res.data
    if (res.meta.status === true) {
      setRevenueAndExpense(data)
    }
  }
  const getRevenueByType = async () => {
    const res = await api.get(`api/financial/dashboard/revenueByType?date=${date ? moment(date).format('yyyy-MM-DD') : ''}`)
    const data = await res.data
    if (res.meta.status === true) {
      setRevenueByType(data)
    }
  }
  //api call
  useEffect(() => {
    getForecast()
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [year]);
  useEffect(() => {
    getRevenueAndExpense()
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [value]);
  useEffect(() => {
    getRevenueByType()
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [date]);

  const dataForecast = forecast?.map((x) => {
    return {
      "id": x?.MonthName,
      "label": x?.MonthName,
      "value": parseFloat(x?.ForecastAmount).toFixed(2),
      // "color": "hsl(218, 70%, 50%)"
    }
  })
  const options = {
    chart: {
      type: 'spline'
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    series: [
      {
        name: 'ExtraExpenseAmount',
        data: revenueAndExpense?.map((x) => +x?.ExtraExpenseAmount.toFixed(2))
      },
      {
        name: 'AdvancePaymentAmount',
        data: revenueAndExpense?.map((x) => +x?.AdvancePaymentAmount.toFixed(2))
      },
      {
        name: 'CostAmount',
        data: revenueAndExpense?.map((x) => +x?.CostAmount.toFixed(2))
      },
      {
        name: 'IncomeAmount',
        data: revenueAndExpense?.map((x) => +x?.IncomeAmount.toFixed(2))
      }
    ],

    credits: {
      enabled: false
    },
  }
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          Payment
        </h6>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={4}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Grid container spacing={2} columns={16}>
                <Grid item xs={8}>
                  <h4>Forecasting </h4>
                  <h6 style={{ color: "gray" }}>ประมาณการรายได้ </h6>
                </Grid>
                <Grid item xs={8}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                      <DatePicker
                        views={["year"]}
                        label="Year only"
                        value={year}
                        onChange={(newValue) => {
                          setYear(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{ width: "150px" }}
                            helperText={null}
                          />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <div style={{ marginTop: 10, height: 400 }}>
                {/* <center>
                  <h5>กำลังประมวลผล</h5>
                </center> */}
                {/* <ResponsivePie
                  data={dataForecast}
                  margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                  innerRadius={0.5}
                  padAngle={0.7}
                  cornerRadius={3}
                  activeOuterRadiusOffset={8}
                  borderWidth={1}
                  borderColor={{
                    from: 'color',
                    modifiers: [
                      [
                        'darker',
                        0.2
                      ]
                    ]
                  }}
                  arcLinkLabelsSkipAngle={10}
                  arcLinkLabelsTextColor="#333333"
                  arcLinkLabelsThickness={2}
                  enableArcLabels={false}
                  arcLinkLabelsColor={{ from: 'color' }}
                  arcLabelsSkipAngle={10}
                  arcLabelsTextColor={{
                    from: 'color',
                    modifiers: [
                      [
                        'darker',
                        2
                      ]
                    ]
                  }}
                  defs={[
                    {
                      id: 'dots',
                      type: 'patternDots',
                      background: 'inherit',
                      color: 'rgba(255, 255, 255, 0.3)',
                      size: 4,
                      padding: 1,
                      stagger: true
                    },
                    {
                      id: 'lines',
                      type: 'patternLines',
                      background: 'inherit',
                      color: 'rgba(255, 255, 255, 0.3)',
                      rotation: -45,
                      lineWidth: 6,
                      spacing: 10
                    }
                  ]}
                  fill={[
                    {
                      match: {
                        id: 'ruby'
                      },
                      id: 'dots'
                    },
                    {
                      match: {
                        id: 'c'
                      },
                      id: 'dots'
                    },
                    {
                      match: {
                        id: 'go'
                      },
                      id: 'dots'
                    },
                    {
                      match: {
                        id: 'python'
                      },
                      id: 'dots'
                    },
                    {
                      match: {
                        id: 'scala'
                      },
                      id: 'lines'
                    },
                    {
                      match: {
                        id: 'lisp'
                      },
                      id: 'lines'
                    },
                    {
                      match: {
                        id: 'elixir'
                      },
                      id: 'lines'
                    },
                    {
                      match: {
                        id: 'javascript'
                      },
                      id: 'lines'
                    }
                  ]}
                // legends={[
                //   {
                //     anchor: 'bottom',
                //     direction: 'row',
                //     justify: false,
                //     translateX: 0,
                //     translateY: 56,
                //     itemsSpacing: 0,
                //     itemWidth: 100,
                //     itemHeight: 18,
                //     itemTextColor: '#999',
                //     itemDirection: 'left-to-right',
                //     itemOpacity: 1,
                //     symbolSize: 18,
                //     symbolShape: 'circle',
                //     effects: [
                //       {
                //         on: 'hover',
                //         style: {
                //           itemTextColor: '#000'
                //         }
                //       }
                //     ]
                //   }
                // ]}
                /> */}
                <HighchartsReact
                  highcharts={Highcharts}
                  options={{
                    chart: {
                      type: "column"
                    },
                    title: {
                      text: null
                    },
                    xAxis: {
                      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                    },
                    yAxis: {
                      title: {
                        text: null
                      },
                    },
                   
                    series: [{
                      type: 'column',
                      name: 'Amount',
                      colorByPoint: true,
                      data: forecast?.map((x) => +x?.ForecastAmount.toFixed(2)),
                      showInLegend: false
                    }]
                    ,

                    credits: {
                      enabled: false
                    },
                  }}
                />
              </div>
            </Card>
          </Grid>
          <Grid item xs={8}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Grid container spacing={2} columns={16}>
                <Grid item xs={8}>
                  <h4>Revenues - Expenses </h4>
                  <h6 style={{ color: "gray" }}>รายได้ - ค่าใช้จ่าย </h6>
                </Grid>
                <Grid item xs={8}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                      <DatePicker
                        views={["year"]}
                        label="Year only"
                        value={value}
                        onChange={(newValue) => {
                          setValue(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{ width: "150px" }}
                            helperText={null}
                          />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <div style={{ height: 400 }}>
                {/* <LineChart revenueAndExpense={revenueAndExpense} /> */}
                <HighchartsReact highcharts={Highcharts} options={options} />
              </div>
            </Card>
          </Grid>
        </Grid>

        <Grid sx={{ mt: 2 }} xs={12}>
          <Card variant="outlined" sx={{ p: 2 }}>
            <Grid container spacing={2} columns={16}>
              <Grid item xs={8}>
                <h4>Realized Revenue </h4>
                <h6 style={{ color: "gray" }}>รายได้แยกตามประเภท </h6>
              </Grid>
              <Grid item xs={8}>
                <div style={{ display: "flex" }}>
                  {/* <FormControl sx={{ width: 200, mr: 5 }}>
                    <InputLabel id="demo-simple-select-label">TYPE</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={type}
                      label="TYPE"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl> */}
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                      <DatePicker
                        views={["month", "year"]}
                        label="Month Year"
                        value={date}
                        onChange={(newValue) => {
                          setDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{ width: "150px" }}
                            helperText={null}
                          />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </div>
              </Grid>
            </Grid>

            <div>
              {/* <ResponsiveBar
                data={data}
                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                padding={0.3}
                height={600}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={{ scheme: 'nivo' }}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legendPosition: 'middle',
                  legendOffset: 32
                }}
                labelTextColor={{
                  from: 'color',
                  modifiers: [
                    [
                      'darker',
                      1.6
                    ]
                  ]
                }}
                defs={[
                  {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: '#38bcb2',
                    size: 4,
                    padding: 1,
                    stagger: true
                  },
                  {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: '#eed312',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                  }
                ]}
                fill={[
                  {
                    match: {
                      id: 'fries'
                    },
                    id: 'dots'
                  },
                  {
                    match: {
                      id: 'sandwich'
                    },
                    id: 'lines'
                  }
                ]}
                borderColor={{
                  from: 'color',
                  modifiers: [
                    [
                      'darker',
                      1.6
                    ]
                  ]
                }}
                keys={["RevemueAmount"]}
                indexBy="Type"
              /> */}
              <HighchartsReact highcharts={Highcharts} options={{
                chart: {
                  type: "column"
                },
                title: {
                  text: null
                },
                xAxis: {
                  categories: ['Ship', 'Train', 'Truck']
                },
                yAxis: {
                  title: {
                    text: null
                  },
                },
                plotOptions: {
                  column: {
                      stacking: 'normal',
                      dataLabels: {
                          enabled: true
                      }
                  }
              },
                series: [{
                  type: 'column',
                  name: 'Amount',
                  colorByPoint: true,
                  data: revenueByType?.map((x) => {
                    return {
                      name: x?.Type,
                      y: +x?.RevemueAmount.toFixed(2),
                      drilldown: x?.Type 
                    }
                  }),
                  showInLegend: false
                }]
                ,

                credits: {
                  enabled: false
                },
              }} />


            </div>
          </Card>
        </Grid>
      </Card>
    </div>
  );
}
